import React from 'react';
import { Feed, Icon, Item } from 'semantic-ui-react';
import moment from 'moment';
import { IPtw } from '@relab/alstom-ptw-shared';

import 'moment/locale/it';
moment.locale('it');

interface PtwDetailCompletionComponentProps {
  ptw: IPtw;
}

export const PtwDetailCompletionComponent = ({ ptw }: PtwDetailCompletionComponentProps) => (
  <React.Fragment>
    {(ptw.refusalComments || ptw.refusalQualityComments) && (
      <Item.Group>
        {ptw.refusalComments && (
          <Item>
            <Item.Content>
              <Item.Header>Refusal comments</Item.Header>
              <Item.Description>
                <p>{ptw.refusalComments}</p>
              </Item.Description>
            </Item.Content>
          </Item>
        )}
        {ptw.refusalQualityComments && (
          <Item>
            <Item.Content>
              <Item.Header>Refusal Quality comments</Item.Header>
              <Item.Description>
                <p>{ptw.refusalQualityComments}</p>
              </Item.Description>
            </Item.Content>
          </Item>
        )}
      </Item.Group>
    )}
    <Feed>
      {ptw.completionStatus.map((completion, i) => (
        <Feed.Event key={i}>
          <Feed.Label>
            <Icon name="star" />
          </Feed.Label>
          <Feed.Content>
            <Feed.Date>{moment(completion.date).format('lll')}</Feed.Date>
            <Feed.Summary>{completion.text}</Feed.Summary>
          </Feed.Content>
        </Feed.Event>
      ))}
    </Feed>
  </React.Fragment>
);
